/**
 * Import required libraries
 */
import React from "react";

/**
 * Import required elements
 */
// Material-ui components
import { Typography } from "@material-ui/core";

import Pseudo from "./pseudo";

import {toCode} from "../EmojiBoard";

import styles from "./styles";

/**
 * Message component
 */
function Message(props) {

  let {
    // uid,
    userUid,
    mine,
    pseudo,
    message
  } = props;

  const from = mine ? null : pseudo;

  // CSS classnames
  const classes = styles(props);

  return (
    <div className={classes.container}>
      {from
        ? <Pseudo userUid={userUid} pseudo={from} />
        : <div className={classes.divider}/>
      }
      <Typography className={classes.text} align="left">
        {toCode(message)}
      </Typography>
    </div>
  );
}

export default Message;
